// Helper para generar URL de ficha técnica oficial Lutron.
// La URL es pública y siempre actualizada (Lutron mantiene sus spec sheets en línea).
// Funciona para SKUs canonicos y variantes; Lutron resuelve el redirect.

// Búsqueda oficial vigente de Lutron (support.lutron.com). Resuelve al modelo y sus
// documentos técnicos (spec submittal). Reemplaza los URLs legacy de www.lutron.com que ya 404ean.
const LUTRON_BASE = 'https://support.lutron.com/us/en/search?q=';

/**
 * Genera la URL de ficha técnica oficial Lutron para un SKU.
 * Funciona para SKUs canonicos (PD-6WCL-WH, RRD-PRO-N) y variantes (RRST-W4B-WH-BL).
 * Lutron resuelve automáticamente al producto correcto.
 */
export function lutronSpecUrl(sku: string | null | undefined): string | null {
  if (!sku) return null;
  return LUTRON_BASE + encodeURIComponent(sku.trim());
}

/**
 * Búsqueda en lutron.com (fallback más amplio si el SKU directo no carga).
 */
export function lutronSearchUrl(sku: string | null | undefined): string | null {
  if (!sku) return null;
  // Búsqueda "modelo + spec" que suele aterrizar en el PDF directo (assets.lutron.com).
  return 'https://www.google.com/search?q=' + encodeURIComponent('lutron ' + sku.trim() + ' specification submittal');
}

/**
 * URL de la página de la línea Lutron (RA3, Caseta, Maestro, etc.) a partir del legacy_lutron_line.
 */
export function lutronLineUrl(line: string | null | undefined): string | null {
  if (!line) return null;
  const map: Record<string, string> = {
    'CASETA':        'https://www.lutron.com/en-US/Pages/Residential/CasetaWireless/Overview.aspx',
    'RADIORA3':      'https://www.lutron.com/en-US/Pages/Residential/RadioRA3/Overview.aspx',
    'RADIORA2':      'https://www.lutron.com/en-US/Pages/Residential/RadioRA2/Overview.aspx',
    'HOMEWORKS QSX': 'https://www.lutron.com/en-US/Pages/Residential/HomeWorksQSX/Overview.aspx',
    'HOMEWORKS':     'https://www.lutron.com/en-US/Pages/Residential/HomeWorksQSX/Overview.aspx',
    'MAESTRO':       'https://www.lutron.com/en-US/Pages/Residential/Maestro/Overview.aspx',
    'WALLBOX':       'https://www.lutron.com/en-US/Pages/Residential/StandAloneControls/Overview.aspx',
    'VIVE':          'https://www.lutron.com/en-US/Pages/Commercial/Vive/Overview.aspx',
    'SUNNATA':       'https://www.lutron.com/en-US/Pages/Residential/Sunnata/Overview.aspx',
    'NOVAT':         'https://www.lutron.com/en-US/Pages/Residential/NovaT/Overview.aspx',
    'LUMARIS':       'https://www.lutron.com/en-US/Pages/Commercial/Lumaris/Overview.aspx',
  };
  return map[line] ?? null;
}
